import * as moment from 'moment'

/**
 * Mock data
 */
const MOCKDATES = {
  startDateTime: moment().subtract(3, 'month').format('YYYY-MM-DD'),
  endDateTime: moment().add(1, 'month').format('YYYY-MM-DD'),
  daysFromPurchase: 90,
  openTime: '07:00Z',
  closeTime: '18:00Z',
}

const MOCKFIELDS = [
  { displayName: 'First Name', priority: 1, field: 'firstName', required: true },
  { displayName: 'Last Name', priority: 1, hint: 'Your last name', field: 'lastName', required: true },
  { displayName: 'Mobile Number', priority: 1, field: 'mobileNo', required: true },
  { displayName: 'Email', priority: 1, field: 'email', required: true },
  { displayName: 'Postcode', priority: 1, field: 'postcode', required: true },
  { displayName: 'Address One', priority: 1, field: 'addressOne', required: true },
  { displayName: 'Address Two', priority: 1, field: 'addressTwo', required: false },
  { displayName: 'City', priority: 1, field: 'city', required: true },
  { displayName: 'County', priority: 1, field: 'county', required: true },
  { displayName: 'Country', priority: 1, field: 'country', required: true },

  { displayName: 'Separator', priority: 2, field: 'separator', required: false },

  { displayName: 'URN', priority: 3, field: 'URN', required: true },
  { displayName: 'Product Id', priority: 3, field: 'productId', values: 'paper,steak,Hat,Coat', required: true },
  {
    displayName: 'Prize Select',
    priority: 3,
    field: 'prizeSelect',
    values: 'pen,pan,knife,Gloves,Umbrella',
    required: true,
  },
  { displayName: 'Purchase Id', priority: 3, field: 'purchaseId', required: true },
  { displayName: 'Serial Id', priority: 3, field: 'serialId', required: true },
  { displayName: 'Batch Code', priority: 3, field: 'batchCode', required: true },
  { displayName: 'Purchase Date', priority: 3, field: 'purchaseDate', required: true },
  { displayName: 'Purchase Type', priority: 3, field: 'purchaseType', values: 'domestic,business', required: true },
  {
    displayName: 'Place of Purchase',
    priority: 3,
    hint: 'Where you bought the product',
    field: 'placeOfPurchase',
    required: true,
  },
  { displayName: 'Proof of Purchase', priority: 3, field: 'proofOfPurchase', required: true },
  { displayName: 'Proof of Product', priority: 3, field: 'proofOfProduct', required: true },

  { displayName: 'Separator', priority: 4, field: 'separator', required: false },

  { displayName: 'Email Opt Out', priority: 5, field: 'emailOptOut', required: false },
  { displayName: 'SMS Opt Out', priority: 5, field: 'smsOptOut', required: false },
  { displayName: 'Marketing Opt In', priority: 5, field: 'marketingOptIn', required: false },
  { displayName: 'Product Opt In', priority: 5, field: 'productOptIn', required: false },
  { displayName: 'Privacy Terms', priority: 5, field: 'privacyTerms', required: true },
  { displayName: 'Terms & Conditions', priority: 5, field: 'termsAndConditions', required: true },
  { displayName: "I'm not a robot", priority: 5, field: 'captcha', required: true },
]

const MOCKUNIVERSE = {
  lookupField: 'prizeSelect',
  qualifyingField: 'productId',
}

const MOCKPRIZES = [
  { name: 'Pen', lookupValue: 'pen', qualifyingValue: 'paper' },
  { name: 'Pan', lookupValue: 'pan', qualifyingValue: 'steak' },
  { name: 'Knife', lookupValue: 'knife', qualifyingValue: 'steak' },
  { name: 'Gloves', lookupValue: 'Gloves', qualifyingValue: 'Hat,paper' },
  { name: 'Umbrella', lookupValue: 'Umbrella', qualifyingValue: 'Coat,steak,Hat' },
]

/**
 * Submission
 */

// Duplicated in campaign-manager/src/content/Submissions/Manual.ts
const SUBMISSIONFORMFIELDTYPES: Field.Types = {
  checkbox: [
    'termsAndConditions',
    'privacyTerms',
    'marketingOptIn',
    'productOptIn',
    'captcha',
    'emailOptOut',
    'smsOptOut',
  ],
  upload: ['proofOfPurchase', 'proofOfProduct', 'proofOfPackaging'],
  radio: ['gender'],
  select: ['prizeSelect', 'purchaseType', 'title'],
  searchSelect: ['productId'],
  selectPackaging: ['packagingMaterial'],
  date: ['purchaseDate', 'dob'],
  email: ['email'],
  tel: ['mobileNo', 'landlineNo'],
  currency: ['purchasePrice', 'totalPrice', 'qualifiedPrice'],
  bankDetails: 'bankDetails',
  reasonForClaim: 'reasonForClaim',
  rewardTrackingOptIn: 'rewardTrackingOptIn',
  purchaseInformation: 'purchaseInformation',
  text: 'default',
}

const SUBMISSIONFORMPRESETOPTIONS: Submission.PresetOptions = {
  gender: [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'no-say', label: 'Prefer Not to Say' },
  ],
  title: [
    { value: 'Mr', label: 'Mr' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Miss', label: 'Miss' },
    { value: 'Mx', label: 'Mx' },
    { value: 'Dr', label: 'Dr' },
  ],
}

const SUBMISSIONFORMDEFAULTOPTIONS: Submission.PresetOptions = {
  reasonForClaim: [{ value: 'other', label: 'Other' }],
}

//WHEN ADDING STATUSES HERE, CHECK: campaign-manager/src/content/config.ts
const SUBMISSIONSTATUSGROUPS: Submission.StatusGroups = {
  'Fraud Flag': ['entry-AutoRejected'],
  Accepted: ['won', 'won-DetailsAdded', 'won-Dispatching', 'won-DispatchFailed', 'won-DispatchCancelled'],
  Dispatched: ['won-Dispatched', 'won-Delivered', 'won-Claimed', 'won-PaymentCreated', 'won-Paid'],
  Lost: ['invalidEntryReceived', 'rejectedInvalid', 'entry-ConfirmedRejected', 'won-Rejected', 'lost'],
  Received: [
    'entry-AwaitValidation',
    'entry-CheckOk',
    'entry-CheckWin',
    'clientOverriden',
    'entry-InComplete',
    'entry-Received',
    'entry-AutoOk',
    'entry-ManOk',
    'won-Possible',
  ],
}

export {
  MOCKDATES,
  MOCKFIELDS,
  MOCKUNIVERSE,
  MOCKPRIZES,
  SUBMISSIONFORMFIELDTYPES,
  SUBMISSIONFORMPRESETOPTIONS,
  SUBMISSIONFORMDEFAULTOPTIONS,
  SUBMISSIONSTATUSGROUPS,
}
